import FormattedMessage from 'I18n/components/FormattedMessage';
import { TableHead, TableRow } from 'foundations-components/transitional/components/Table';
import { StyledTableHeaderCell } from './StyledTableHeaderCell';
import { useMilestoneTableSize } from './MilestoneTableSizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MilestoneTableHeader = ({
  hasSuggestions = false
}) => {
  const size = useMilestoneTableSize();
  if (size === 'small') {
    return null;
  }
  return /*#__PURE__*/_jsx(TableHead, {
    sticky: false,
    children: /*#__PURE__*/_jsxs(TableRow, {
      children: [/*#__PURE__*/_jsx(StyledTableHeaderCell, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.milestones.columnMilestone"
        })
      }), /*#__PURE__*/_jsx(StyledTableHeaderCell, {
        inlineSize: size === 'full' ? '165px' : '130px',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.milestones.columnDueDate"
        })
      }), /*#__PURE__*/_jsx(StyledTableHeaderCell, {
        inlineSize: size === 'full' ? '200px' : '48px',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.milestones.columnOwner"
        })
      }), /*#__PURE__*/_jsx(StyledTableHeaderCell, {
        inlineSize: hasSuggestions ? '96px' : '56px'
      })]
    })
  });
};